import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" fill="currentColor" aria-hidden="true"><g fill="#000" fillRule="evenodd"><path d="M17.616 17.039H2.396a.846.846 0 0 1 0-1.691V9.455c0-4.218 3.407-7.637 7.61-7.637 4.202 0 7.61 3.419 7.61 7.637v5.893a.846.846 0 0 1 0 1.691Zm-13.53-1.691h11.839V9.455c0-3.284-2.65-5.946-5.92-5.946-3.268 0-5.918 2.662-5.918 5.946v5.893Zm7.998 2.923a2.114 2.114 0 0 1-4.16-.017.315.315 0 0 1 .31-.37h3.529a.327.327 0 0 1 .321.387Z" fillRule="nonzero" /><rect x={8.823} width={2.273} height={2.727} rx={1.136} /><path d="M13.35 9.457c.451 0 .818.366.818.818v2.91a.818.818 0 1 1-1.637 0v-2.91c0-.452.367-.818.819-.818Z" /></g></svg>

const NavAnnouncement = React.forwardRef((props, ref) => {
  return (
    <IconBase name="nav-announcement" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

NavAnnouncement.displayName = 'IconNavAnnouncement'

export default NavAnnouncement
